:host { /* NOSONAR */
    display: block;
    width: 100%; // this is to make the component respect a flexbox layout in IE11 which is the standard usage

    .ti-training-series-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: $polaris-space-16 0;

        a {
            color: $pl-link-color-primary;
            text-decoration: none;

            &:hover {
                text-decoration: underline;
            }
        }

        img {
            width: 100%;
            margin-bottom: $polaris-space-6;
        }

        ti-carousel { /* NOSONAR */
            margin: $polaris-space-6 0;
            min-height: 1px; //IE11 Flex bugfix
            width: 100%; //IE11 Flex bugfix

            a {
                font-weight: $polaris-font-weight-bold;
                font-size: $polaris-font-h5-size;
                line-height: $polaris-line-height-3;
            }
        }

    }

    .ti-training-series-progress-container {
        display: flex;
        justify-content: center;
        margin: $polaris-space-4;
    }

}
